export default __webpack_public_path__ + "static/media/fuckies-back.652df780.jpg";